import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import withData from 'util/hoc/with-data';
import Loading from 'components/loading';
import { resolve } from 'library/helpers/path-resolver';
import styled from 'styled-components';
import Card from 'apps/trimble-careers/components/card';
import { Link } from 'library/util/core-router';
import Breadcrumbs, { BreadcrumbItem } from 'components/breadcrumbs';

const StyledIndustryBlurbImage = styled.img``;
const StyledIndustryBlurbTitle = styled.p`
  font-size: 1.5em;
  font-weight: bold;
`;
const StyledIndustryBlurbText = styled.p`
  margin: 0;
`;

const IndustryBlurb = ({ image, title, description, color }) => (
  <Card color={color}>
    {/* <StyledIndustryBlurbImage src={image} /> Removed until we can get pictures*/}
    <StyledIndustryBlurbTitle>{title}</StyledIndustryBlurbTitle>
    <StyledIndustryBlurbText dangerouslySetInnerHTML={{__html: description}} />
  </Card>
);

const StyledIndustryBlurbs = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  @media(max-width: 1200px) {
    justify-content: center;
  }
`;
const StyledIndustryCareers = styled.div`
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  ${Card} {
    margin-bottom: 1.5em;
  }
  @media(max-width: 1200px) {
    justify-content: center;
  }
`;
const StyledIndustryPage = styled.section`
  width: 1200px;
  margin: auto;
`;

const IndustryCareerLink = styled.a`
  color: #898989;
  border: 1px solid currentColor;
  border-radius: .5em;
  padding: .5em 1em;
  text-decoration: none;
  float: right;
`;

const StyledIndustryCareerTitle = styled.h3`
  margin: .5em 0;
`;

const IndustryCareer = ({ name, description, slug, industry_slug, color }) => (
  <Card color={color}>
    <StyledIndustryCareerTitle>{ name }</StyledIndustryCareerTitle>
    <p>{ description }</p>
    <Link component={IndustryCareerLink} to={`/trimble/${industry_slug}/${slug}`}>GO</Link>
  </Card>
);

const StyledPageTitle = styled.h1`
  font-size: 3em;
  color: ${props=>props.color};
  font-weight: bold;
  text-align: center;
  margin: .25em 0;
`;

const StyledPageSubtitle = styled.h3`
  text-align: center;
`;
const StyledPageDescription = styled.p`
  text-align: center;
`;

const IndustryPage = ({ graph_loading, graph_data }) => (
  graph_loading
    ? (
      <Loading />
    )
    : (
      <Fragment>
        <Breadcrumbs>
          <BreadcrumbItem to="/trimble">All Paths</BreadcrumbItem>
          <BreadcrumbItem to={`/trimble/${resolve(graph_data, 'industry/slug', '')}`}>{ resolve(graph_data, 'industry/name', '') }</BreadcrumbItem>
        </Breadcrumbs>
        <StyledPageTitle color={resolve(graph_data, 'industry/color', '')}>{resolve(graph_data, 'industry/name', 'ERROR Not Found')}</StyledPageTitle>
        <StyledPageSubtitle>{resolve(graph_data, 'industry/subtitle', 'Error')}</StyledPageSubtitle>
        <StyledPageDescription dangerouslySetInnerHTML={{__html: resolve(graph_data, 'industry/description', '')}} />
        <StyledIndustryBlurbs>
          { resolve(graph_data, 'industry/blurbs', []).filter(c=>c.title).map((data) => (
            <IndustryBlurb key={data.title} color={resolve(graph_data, 'industry/color', '')} {...data} />
          )) }
        </StyledIndustryBlurbs>
        {
          resolve(graph_data, 'industry/careers', []).length
            ? (
              <Fragment>
                <StyledPageSubtitle>{resolve(graph_data, 'industry/pathway_title', 'Find your career pathway')}</StyledPageSubtitle>
                <StyledPageDescription>{resolve(graph_data, 'industry/pathway_header', '')}</StyledPageDescription>
                <StyledIndustryCareers>
                  { resolve(graph_data, 'industry/careers', []).map((data) => (
                    <IndustryCareer key={data.id} color={resolve(graph_data, 'industry/color', '')} {...data} />
                  )) }
                </StyledIndustryCareers>
              </Fragment>
            )
            : null
        }
      </Fragment>
    )
);

IndustryPage.propTypes = {
  match: PropTypes.object
};

IndustryPage.query = async (cancelToken, { match }) => (
  await fetch(`https://fmzhs9h4ah.execute-api.us-east-1.amazonaws.com/trimble/industries/${match.params.industry}`).then(r=>r.json()).then(r=>({data:{industry:r}}))
);

export default withData(IndustryPage);
